import React from "react";
import {
  Switch,
  Route,
  useRouteMatch,
  useLocation,
  Redirect,
} from "react-router-dom";
import Branding from "../../Advanced/BrandingAndCustomization/Branding/Branding";
import Customization from "../../Advanced/BrandingAndCustomization/Customization/Customization";
import {
  RouteTab,
  RouteTabs,
} from "../../../revampComponents/Atom/Tabs/RouteTabs";

const WhiteLabel = (props) => {
  const location = useLocation();
  const { path, url } = useRouteMatch();
  const pathParts = location.pathname.split("/");
  const profileId = pathParts[2];

  return (
    <>
      <div className="BrandingAndCustomization-profile-level">
        <RouteTabs>
          <RouteTab title="Branding" to={`${url}/branding`} />
          <RouteTab title="Customization" to={`${url}/customization`} />
        </RouteTabs>

        <Switch>
          <Route path={`${path}/branding`}>
            <Branding {...props} module="event-profile" profileId={profileId} />
          </Route>
          <Route path={`${path}/customization`}>
            <Customization
              {...props}
              module="event-profile"
              profileId={profileId}
            />
          </Route>
          <Route exact path={path}>
            <Redirect to={`${url}/branding`} />
          </Route>
        </Switch>
      </div>
      <style>
        {`
              .BrandingAndCustomization-profile-level{
                    background-color:#fff;
              } 
                
                `}
      </style>
    </>
  );
};

export default WhiteLabel;
